import { getFullName } from "../careprovider/visits/utils";

export const FALLBACK_ROOM_NAME = "Conversation";

export const getChatRoomId = (room) => String(room?.roomId ?? "");

export const getActiveRoomMembers = (members = []) =>
  members.filter((member) => member?.activeInRoom);

export const isUserActiveInRoom = (room, userIdentifier) => {
  if (!room || !userIdentifier) {
    return false;
  }

  const members = room.members;
  if (!Array.isArray(members) || members.length === 0) {
    return true;
  }

  const currentMember = members.find(
    (member) => String(member?.userIdentifier) === String(userIdentifier),
  );

  if (!currentMember) {
    return false;
  }

  return Boolean(currentMember.activeInRoom);
};

export const normalizeWorkforceToRoomMember = (user) => ({
  userIdentifier: user?.userIdentifier,
  givenName: user?.givenName,
  familyName: user?.familyName,
  jobTitle: user?.jobTitle,
  activeInRoom: true,
});

export const isGroupChatAdmin = (room, currentUserIdentifier) => {
  if (!room || !currentUserIdentifier || room.chatType !== "group") {
    return false;
  }

  if (String(room.createdBy) === String(currentUserIdentifier)) {
    return true;
  }

  const currentMember = room.members?.find(
    (member) => String(member?.userIdentifier) === String(currentUserIdentifier),
  );

  return Boolean(currentMember?.isAdmin ?? currentMember?.admin);
};

export const canRemoveGroupMember = (room, member, memberCount) => {
  if (!room || !member || memberCount <= 1) {
    return false;
  }

  return String(member.userIdentifier) !== String(room.createdBy);
};

const getMemberDisplayName = (member) => {
  if (!member) {
    return FALLBACK_ROOM_NAME;
  }

  const fullName = getFullName(member?.givenName, member?.familyName)

  return (
    fullName || FALLBACK_ROOM_NAME
  );
};

export const getOtherRoomMember = (room, currentUserIdentifier) => {
  if (!room?.members?.length) {
    return null;
  }

  return (
    room.members.find(
      (member) =>
        String(member?.userIdentifier) !== String(currentUserIdentifier),
    ) ?? null
  );
};

export const getChatRoomDisplayName = (room, currentUserIdentifier) => {
  if (!room) {
    return FALLBACK_ROOM_NAME;
  }

  if (room.chatType === "group") {
    return room.title || FALLBACK_ROOM_NAME;
  }

  return getMemberDisplayName(getOtherRoomMember(room, currentUserIdentifier));
};

export const getChatRoomAvatarUser = (room, currentUserIdentifier, displayName) => {
  if (room?.chatType === "group") {
    return { name: displayName };
  }

  const otherMember = getOtherRoomMember(room, currentUserIdentifier);

  return {
    name: displayName,
    givenName: otherMember?.givenName,
    familyName: otherMember?.familyName,
  };
};

export const formatChatRoomTime = (timestamp) => {
  if (!timestamp) {
    return "";
  }

  const date = new Date(timestamp);
  const now = new Date();

  if (date.toDateString() === now.toDateString()) {
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  return date.toLocaleDateString([], {
    month: "short",
    day: "numeric",
  });
};
